
import React from "react";

export default function LoginFooter() {
    const BASE_URL = process.env.REACT_APP_BASE_URL;

    return (
        <div className="login-footer mt-4 text-center">
            <p>
                Copyright © {new Date().getFullYear()}, Vivashri. All Rights Reserved.
            </p>
            <a
                href="https://mightywarner.com"
                className="akslogo-login"
                target="_blank"
                rel="noopener noreferrer"
                title="Mightywarner Infoserve (OPC) Private Limited"
            >
                <img
                    src={`${process.env.PUBLIC_URL || ""}/assets/img/mighty.png`}
                    alt="Mightywarner Infoserve (OPC) Private Limited"
                    title="Mightywarner Infoserve (OPC) Private Limited"
                />
            </a>
        </div>
    );
}